<template>
  <div class="contentBox">
    <div class="bg1" v-if="subType" >
      <div class="icon icon1">
        <div class="icon-txt" v-if="clickType">
            <p class="icon-text">{{clickTxt}}</p>
        </div>
        <input type="number" placeholder="请输入兑换码" v-model="codeNum" v-else>
        <button class="btn btn-click" @click="clickSub" v-if="!clickType"></button>
      </div>
      <div class="icon icon2"></div>
      <div class="icon icon3"></div>
      <div class="icon icon4"></div>
      <button class="btn btn-updown" @click="updownSub"></button>
    </div>

    <div class="bg" v-else>
      <button class="btn btn-draw" @click="drawShow"></button>
    </div>

    <div class="codeBox" v-if="codeType">
      <div class="bg">
        <button class="btn btn-close" @click="loginHide">+</button>
        <div class="txt mobile">
          <p class="">手机号</p>
          <input type="number" placeholder="请输入手机号" v-model="mobile" @input="numCheck(mobile,11,'mobile')">
        </div>
        <div class="txt code">
          <p class="">验证码</p>
          <div class="code-bg">
            <input type="number" placeholder="请输入验证码" v-model="code"/>
            <button class="btn btn-code" @click="getCode">{{codeTxt}}</button>
          </div>
        </div>
        <button class="btn btn-sub" @click="loginSub"></button>
      </div>
    </div>
  </div>

</template>
<script>
import { sendVerificationCode ,NewcaptchaLogin,giveVip ,exchangeVerifyCode} from "@/assets/js/api";
export default {
  name: "login",
  data() {
    return {
      codeType:false,
      subType:false,
      mobile:'',
      code:'',
      isSendCode:false,
      countDownNum:60,
      codeTxt:'获取验证码',
      token:'',
      codeNum:'',
      clickType:false,
      clickTxt:''
    };
  },
  components: {
    
  },
  watch: {
    $route() {
      window.location.reload();
    }
  },
  mounted(){
    this.font_resize();
    document.title='助力自信发声'
  },
  methods: {
    font_resize(){
      var size=document.documentElement.clientWidth / 750 * 100;
      document.querySelector('html').style.fontSize=size + 'px';
    },

    drawShow(){
      this.codeType = true;
    },

    //获取验证码
    async getCode(){
      var that = this;
      var mobile = this.mobile;
      var regex = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
      if(mobile === '' || !regex.test(mobile)){
          that.$message('请输入正确的手机号码！');
          return false;
      };
      if(this.isSendCode){
          that.$message('请勿重复点击！');
          return false;
      };
      var data = {
        mobile:mobile
      };
      try {
        const response = await sendVerificationCode(data);
        console.log(response,'==response==')
        if(response.code == 200){
          that.isSendCode = true;
          var setCountDown = setInterval(function() {
              that.countDownNum--;
              that.codeTxt = that.countDownNum+'s';
              if (that.countDownNum == 0) {
                  clearInterval(setCountDown);
                  that.countDownNum = 60;
                  that.isSendCode = false;
                  that.codeTxt = '重新发送';
              };
          }, 1000);
        } else {
          that.countDownNum = 60;
          that.isSendCode = false;
          that.$message(data.msg);
        }
      } catch (error) {
        that.$message(error);
        that.countDownNum = 60;
        that.isSendCode = false;
        that.$message(data.msg);
      }
    },

    async loginSub(){
      var that = this;
      if(this.mobile == ''){
        this.$message('请输入正确的账号！');
        return false;
      }
      if(this.code == ''){
        this.$message('请输入正确的验证码！');
        return false;
      }
      try {
        const response = await NewcaptchaLogin({mobile:this.mobile,code:this.code});
        if(response.code == 200){
          that.token = response.data.token;
          that.codeType = false;
          that.mobile = '';
          that.code = '';
          that.isSendCode = false;
          that.countDownNum = 60;
          that.codeTxt = '获取验证码';
          that.subType = true;
        } else {
          that.$message(data.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    loginHide(){
      var that = this;
      that.codeType = false;
      that.mobile = '';
      that.code = '';
      that.isSendCode = false;
      that.countDownNum = 60;
      that.codeTxt = '获取验证码';
    },

    numCheck(e,i,type){
      var that = this;
      var num = e;
      num = num.length;
      if(num > i){
          if(type == 'mobile'){
              e = e.slice(0,11);
              that.mobile = e;
          } else {
              that.code = JSON.stringify(e).slice(0,4)
          }
      }
    },

    async clickSub(){
      var that = this;
      if(this.codeNum == ''){
        this.$message('请输入正确的兑换码！');
        return false;
      }
      try {
        const response = await exchangeVerifyCode({code:this.codeNum},this.token);
        if(response.code == 200){
          that.clickType = true;
          that.clickTxt = '兑换成功';
          that.codeNum = '';
        } else {
          that.$message(data.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    updownSub(){
      var client = '';
      var u = navigator.userAgent,app = navigator.appVersion;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      var isIOS = !u.match(/\(i[^;]+;( U;)? CPU,+Mac OS X/);
      if(isAndroid){
          client = 'android'
      }else {
          client = 'ios'
      };
      if (client == 'ios') {
        window.location.href = 'https://apps.apple.com/cn/app/智能演讲教练/id6744727526';
      } else {
        window.location.href = 'https://m.malink.cn/s/UzyUva';
      };
    }
  }  
};
</script>
<style scoped>
  .contentBox{
    overflow-y: auto;
    overflow-x: hidden;
  }

  .contentBox .bg{
    background-image: url(~@/assets/images/bg1.png);
    width: 100%;
    height: 29.43rem;
    background-size: 100% 29.43rem;
    position: relative;
  }

  .btn-draw{
    background-image: url(~@/assets/images/code-btn1.png);
    width: 5rem;
    height: 1.09rem;
    background-size: 5rem 1.09rem;
    position: absolute;
    top: 10.41rem;
    left: 50%;
    transform: translate(-50%,0);
  }

  .codeBox{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .6);
  }

  .codeBox .bg{
    background-image: url(~@/assets/images/code-bg1.png);
    width: 100%;
    height: 6.79rem;
    background-size: 100% 6.79rem;
    position: absolute;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    padding: 1rem .3rem;
    box-sizing: border-box;
  }

  .codeBox .bg .txt{
    margin-bottom: .3rem;
  }

  .codeBox .bg .txt p{
    color: #333333;
    font-size: .3rem;
    margin-bottom: .2rem;
  }

  .codeBox .bg .mobile input{
    width: 100%;
    height: .96rem;
    line-height: .96rem;
    color: #AAAAAA;
    font-size: .28rem;
    border-radius: .2rem;
    box-sizing: border-box;
    padding: 0 .3rem;
  }

  .codeBox .bg .code .code-bg{
    background-color: #fff;
    border-radius: .2rem;
  }

  .codeBox .bg .code input{
    width: 50%;
    height: .96rem;
    line-height: .96rem;
    display: inline-block;
    vertical-align: top;
    color: #AAAAAA;
    font-size: .28rem;
    box-sizing: border-box;
    padding: 0 .3rem;
    background-color: transparent;
  }

  .codeBox .bg .code .btn-code{
    font-size: .24rme;
    line-height: .96rem;
    height: .96rem;
    color: #6E2FFF;
    display: inline-block;
    vertical-align: top;
    width: 50%;
    text-align: right;
    padding-right: .2rem;
    box-sizing: border-box;
  }

  .btn-close{
    font-size: 1rem;
    color: #666666;
    position: absolute;
    top: 0rem;
    right: .3rem;
    transform: rotate(45deg);
  }

  .btn-sub{
    background-image: url(~@/assets/images/code-btn2.png);
    width: 5.7rem;
    height: 1.09rem;
    background-size: 5.7rem 1.09rem;
    display: block;
    margin: 0.6rem auto 0;
  }

  .bg1{
    background-image: url(~@/assets/images/code-bg2.png);
    width: 100%;
    height: 34.19rem;
    background-size: 100% 34.19rem;
    overflow: hidden;
  }

  .bg1 .icon1{
    background-image: url(~@/assets/images/code-bg3.png);
    width: 6.9rem;
    height: 5.06rem;
    background-size: 6.9rem 5.06rem;
    display: block;
    margin: 7.79rem auto 0;
    overflow: hidden;
  }

  .bg1 .icon1 input{
    width: 6.5rem;
    height: 1.18rem;
    line-height: 1.18rem;
    border-radius: .2rem;
    background-color: #fff;
    display: block;
    margin: 1.43rem auto 0;
    font-size: .38rem;
    color: #AAAAAA;
    box-sizing: border-box;
    padding: 0 .2rem;
  }

  .bg1 .icon1 .btn-click{
    background-image: url(~@/assets/images/code-btn4.png);
    width: 5.18rem;
    height: 1.09rem;
    background-size: 5.18rem 1.09rem;
    display: block;
    margin: .7rem auto 0;
  }

  .bg1 .icon2{
    background-image: url(~@/assets/images/code-icon1.png);
    width: 6.9rem;
    height: 7.31rem;
    background-size: 6.9rem 7.31rem;
    display: block;
    margin: .6rem auto 0;
  }

  .bg1 .icon3{
    background-image: url(~@/assets/images/code-icon2.png);
    width: 6.9rem;
    height: 7.74rem;
    background-size: 6.9rem 7.74rem;
    display: block;
    margin: .6rem auto 0;
  }

  .bg1 .icon4{
    background-image: url(~@/assets/images/code-icon3.png);
    width: 6.9rem;
    height: 1.6rem;
    background-size: 6.9rem 1.6rem;
    display: block;
    margin: .6rem auto 0;
  }

  .bg1 .btn-updown{
    background-image: url(~@/assets/images/code-btn3.png);
    width: 5rem;
    height: 1.09rem;
    background-size: 5rem 1.09rem;
    display: block;
    margin: .6rem auto 0;
  }

   .icon-txt{
      width: 6.5rem;
      height: 1.18rem;
      border-radius: .2rem;
      background-color: #fff;
      display: block;
      margin: 1.43rem auto 0;
      box-sizing: border-box;
      padding: 0 .2rem;
      overflow: hidden;
    }
    
    .icon-txt .icon-text{
      background-color: #FF2D2D;
      border-radius: .34rem;
      color: #fff;
      font-size: .28rem;
      width: 4.04rem;
      height: .68rem;
      line-height: .68rem;
      margin: .25rem auto;
      display: block;
      text-align: center;
    }

  ::-webkit-scrollbar{
    width: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/mobile/code.vue